import React from 'react';
import { LegalPage } from './LegalPage';

export const PrivacyPage = () => <LegalPage page="privacy" />;
